<div *ngIf="!isSubMenu">
  <ul id="category-list" class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
    <div *ngFor="let item of menu; let i = index">
      <li id="item-{{i}}" [ngClass]="{'dropdown-submenu': item.children && item.children.length > 0}">
        <a *ngIf="!item.children || item.children.length === 0" (click)="navigateCategory(item)"
          class="dropdown-item">{{item.title}}</a>

        <a *ngIf="item.children && item.children.length > 0" (click)="navigateCategory(item)"
          class="dropdown-item hasChild">{{item.title}}</a>
        <div *ngIf="item.children && item.children.length > 0">
          <ultra-category-menu [menu]="item.children" isSubMenu="true" [index]="i"></ultra-category-menu>
        </div>
      </li>
    </div>
  </ul>
</div>


<ul id="sub-category-list-{{index}}" *ngIf="menu && menu.length > 0" class="dropdown-menu" (mouseenter)="enterMouse()" (mouseleave)="leaveMouse()"
  [ngClass]="{'scrollable-menu': isScrollable}">
  <li class="dropdown-submenu" *ngFor="let item of menu">
    <a [ngClass]="{'hasChild': item.children && item.children.length > 0}" class="dropdown-item"
      (click)="navigateCategory(item)">
      {{item.title}}
    </a>
    <div *ngIf="item.children && item.children.length > 0">
      <ultra-category-menu [isScrollable]="item.children.length > 10" [menu]="item.children"
        isSubMenu="true"></ultra-category-menu>
    </div>
  </li>
</ul>